import {
  DiscountType,
  RecallType,
  SherpaConditionFragment,
  SherpaConditionType,
} from "../../../../gql/hooks";

type ProductCCType = {
  packagedProductCode: string;
  discountValue?: number | null | undefined;
  discountType?: DiscountType | null | undefined;
  amortizationValue?: number | null;
  amortizationType?: RecallType | null;
  amortizationX?: number | null;
  amortizationY?: number | null;
  recallValue?: number | null;
  recallType?: RecallType | null;
  recallX?: number | null;
  recallY?: number | null;
  packagedProductPrice?: number | null;
  packagedProductUnitsNb: number;
  x?: number | null;
  y?: number | null;
  freePackagedProductUnitsNb?: number | null;
};

const discountAmortizationRappel = (
  discountType: DiscountType,
  notRappel?: boolean,
) => {
  if (discountType === DiscountType.EuroPerLiter) {
    return notRappel ? RecallType.EuroPerLiterLoan : RecallType.LiterRecall;
  }
  if (discountType === DiscountType.EuroPerUnit) {
    return notRappel ? RecallType.EuroPerUnitLoan : RecallType.UnitRecall;
  }
  if (discountType === DiscountType.Percentage) {
    return notRappel ? RecallType.PercentageLoan : RecallType.PercentageRecall;
  }
  if (discountType === DiscountType.XY) {
    return notRappel ? RecallType.XYLoan : RecallType.XYRecall;
  }
  return undefined;
};

const evaluateCPVConditions = (
  cpvs: SherpaConditionFragment[],
  externalId?: string,
) => {
  const productCCs = cpvs.reduce(
    (acc, cpv) => {
      if (cpv.conditionType === SherpaConditionType.FreeProducts) {
        acc.freePackagedProductUnitsNb = cpv.x || 0;
      }

      // Discount
      if (cpv.discountType && cpv.conditionType === SherpaConditionType.Fixed) {
        // Leave empty for now
        acc.discountType = cpv.discountType;
        if (cpv.discountType === DiscountType.XY) {
          acc.x = cpv.x;
          acc.y = cpv.y;
        } else {
          acc.discountValue = cpv.x;
        }
      }

      // Rappel
      if (
        cpv.discountType &&
        cpv.conditionType === SherpaConditionType.Deferred
      ) {
        // Leave empty for now
        acc.recallType = discountAmortizationRappel(cpv.discountType);
        if (cpv.discountType === DiscountType.XY) {
          acc.recallX = cpv.x;
          acc.recallY = cpv.y;
        } else {
          acc.recallValue = cpv.x;
        }
      }

      // Amortization
      if (
        cpv.discountType &&
        cpv.conditionType === SherpaConditionType.Amortization
      ) {
        acc.amortizationType = discountAmortizationRappel(
          cpv.discountType,
          true,
        );
        if (cpv.discountType === DiscountType.XY) {
          acc.amortizationX = cpv.x;
          acc.amortizationY = cpv.y;
        } else {
          acc.amortizationValue = cpv.x;
        }
      }

      return acc;
    },
    {
      packagedProductCode: externalId,
      discountValue: undefined,
      discountType: undefined,
      amortizationValue: undefined,
      amortizationType: undefined,
      recallValue: undefined,
      recallType: undefined,
      recallX: undefined,
      recallY: undefined,
      amortizationX: undefined,
      amortizationY: undefined,
      packagedProductUnitsNb: 0,
      x: undefined,
      y: undefined,
      freePackagedProductUnitsNb: undefined,
    } as ProductCCType,
  );

  return productCCs;
};

export default evaluateCPVConditions;
